<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
  </cTable>
</template>

<script>
import { getList, exportFun } from "@/api/order/pakistanPost";
import Tracker from "@/base/order_tracker";
import { getAllClient } from "@/api/user/client";
import cTable from "@/base/common/index";
export default {
  name: "pakistanPost",
  components: {
    cTable,
    Tracker,
  },
  async created() {
    let client = (await getAllClient()).data.payload.rows;
    this.header.searchs.forEach(async (item) => {
      if (item.key === "client_id") item.options = client;
    });
  },
  data() {
    return {
      amount: 0,
      methods: {
        list: getList,
        getAllClient,
        exportFun,
        // getDetails
      },
      config: {
        height: 630,
      },
      modals: {},
      header: {
        searchs: [
          {
            key: "is_export",
            component: "Select",
            bind: {
              style: "width:175px",
            },
            placeholder() {
              return this.$t("whether") + this.$t("export");
            },
            options: [
              {
                label: this.$t("YES"),
                value: "YES",
              },
              {
                label: this.$t("NO"),
                value: "NO",
              },
            ],
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1,
              // autosize: { minRows: 2, maxRows: 2 }
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              let data = {
                airway_number: this.selectAll.map((item) => item.airway_number),
              };
              this.handleRequestMethods("exportFun", data, false, true).then(
                (res) => {
                  window.open(this.$globalUrl + res.payload);
                }
              );
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("orderNum"),
          key: "airway_number",
          align: "center",
          minWidth: 95,
        },
        {
          name: () => this.$t("order_refCode"),
          key: "agent_refer_code",
          align: "center",
          minWidth: 95,
        },
        {
          name: () => this.$t("pay") + this.$t("type"),
          key: "cod_type",
          align: "center",
          minWidth: 95,
        },
        {
          name: () => this.$t("pay") + this.$t("reChAmount"),
          key: "cod_amount",
          align: "center",
          minWidth: 95,
        },
        {
          name: () => this.$t("claim_t") + this.$t("invoiceWeight"),
          key: "claim_weight",
          align: "center",
          minWidth: 95,
        },
        {
          name: () => this.$t("actual_weight"),
          key: "check_weight",
          align: "center",
          minWidth: 95,
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          align: "center",
          minWidth: 95,
        },
        {
          name: () => this.$t("order_desc"),
          key: "remarks",
          align: "center",
          minWidth: 95,
        },
        {
          name: () => this.$t("expTime"),
          key: "report_time",
          align: "center",
          minWidth: 150,
        },
        {
          name: () => this.$t("export") + this.$t("personnel"),
          key: "operator_name",
          align: "center",
          minWidth: 100,
        },
        // {
        //   type: "btns",
        //   width: 100,
        //   name: () => this.$t("operation"),
        //   fixed: "right",
        //   list: [
        //     {
        //       name: () => this.$t("operation"),
        //       type: "operation",
        //       fnName: "operationFun",
        //       bind: {
        //         type: "warning"
        //       }
        //     }
        //   ],

        //   methods: {
        //     operationFun({ row }) {
        //       this.getModal("operation").open({ id: row.airway_number });
        //     }
        //   }
        // }
      ],
    };
  },
};
</script>
